// Local keyword bank powering the hero search autocomplete.
// (Pixabay has no suggest endpoint, so we filter this curated list client-side.)
const SUGGESTIONS = [
    'nature', 'landscape', 'mountains', 'ocean', 'beach', 'sunset', 'sky',
    'forest', 'flowers', 'plants', 'animals', 'dog', 'cat', 'birds', 'wildlife',
    'people', 'portrait', 'woman', 'man', 'children', 'family', 'friends',
    'business', 'office', 'meeting', 'startup', 'money', 'finance', 'marketing',
    'technology', 'computer', 'laptop', 'coding', 'data', 'ai', 'robot',
    'food', 'coffee', 'breakfast', 'fruit', 'vegetables', 'dessert', 'cooking',
    'travel', 'city', 'architecture', 'building', 'street', 'road', 'car',
    'fitness', 'yoga', 'sports', 'health', 'medical', 'science',
    'music', 'party', 'celebration', 'wedding', 'love', 'fashion', 'beauty',
    'abstract', 'background', 'texture', 'pattern', 'minimal', 'gradient',
    'winter', 'summer', 'autumn', 'spring', 'rain', 'snow', 'christmas',
    'work', 'home', 'interior', 'design', 'art', 'education', 'school',
];

export default SUGGESTIONS;
